/**
 * Module Api Schema - Routes Registry
 */
import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import { PAGE_URLS } from "../constants";

const ApiPlayground = React.lazy(() => import('../ApiPlayground'));
const ApiProject = React.lazy(() => import('../ApiProject'));
const ApiProjectDetail = React.lazy(() => import('../ApiProject/ApiProjectDetail'));
const ApiEnvironment = React.lazy(() => import('../ApiEnvironment'));
const ApiSavedRequest = React.lazy(() => import('../ApiSavedRequest'));
const ApiRequestHistory = React.lazy(() => import('../ApiRequestHistory'));

const apiSchemaRoutesRegistry = [
    {
        path: PAGE_URLS.API_PLAYGROUND,
        element: <ApiPlayground />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: PAGE_URLS.API_PROJECT,
        element: <ApiProject />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: `${PAGE_URLS.API_PROJECT_DETAIL}/:id`,
        element: <ApiProjectDetail />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: PAGE_URLS.API_ENVIRONMENT,
        element: <ApiEnvironment />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: PAGE_URLS.API_SAVED_REQUEST,
        element: <ApiSavedRequest />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: PAGE_URLS.API_REQUEST_HISTORY,
        element: <ApiRequestHistory />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default apiSchemaRoutesRegistry;
